import customerListId from "./customer-list/id";
import customerPurchasesId from "./customer-purchases/id";
import debtPaymentId from "./debt-payment/id";
import debtReportId from "./debt-report/id";

const customerId = {
	customer: {
		title: "Pelanggan",
		subtitle: "Manajemen pelanggan dan laporan",
		...customerListId,
		...customerPurchasesId,
		...debtPaymentId,
		...debtReportId,
	},
};

export default customerId;
